import React, { useCallback, useEffect } from 'react'
import type { FC } from 'react'
import {} from 'mailup-web-components'
import PageContainer from 'Components/PageContainer'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import { addAgentDeclarationLogCallback, initCallback, resetCallback } from './recoil/callbacks/callbacks'
import { composerState } from './recoil/states/page'
import ErrorFeedback from 'Components/ErrorFeedback'
import Header from './components/Header'
import { useIntl } from 'react-intl'
import iconAgent from '../../img/icon-agent-rcs.svg'
import { getLang } from 'mailup-react-helpers'
import { pageState } from '../../state/page'
import Page from 'Containers/Page'
import { composerData } from './types'

const RcsBot: FC = () => {
  const intl = useIntl()
  const { loading, errorMessage, status } = useRecoilValue(pageState)
  const {
    token,
    dynamicFields,
    brandName,
    senderPhoneNumbers,
    senderAlias
  } = useRecoilValue(composerState)
  const init = useRecoilCallback(initCallback, [])
  const resetState = useRecoilCallback(resetCallback, [])
  const addAgentDeclarationLog = useRecoilCallback(
    addAgentDeclarationLogCallback,
    []
  )
  useEffect(() => {
    init()

    return () => {
      resetState()
    }
  }, [init, resetState])

   // @ts-ignore
  const composerRef = useCallback((el: HTMLDivElement | null): void => {
    if (el !== null && token !== "") {

       // @ts-ignore
      const agentListRoot = window.ReactDOM.createRoot(
        document.getElementById('agent-list')
      )

      agentListRoot.render(
         // @ts-ignore
        React.createElement(window.AgileComposer.Main, {
          language: getLang(),

          token: token,
          command: 'agent-list',
          variables: dynamicFields,
          brandName: brandName,
          senderPhoneNumbers: senderPhoneNumbers,
          senderAliases: senderAlias,
          callback: callback,
          customerUi: {
            'generic.colors.primary': '#16A7CD',
            'generic.colors.hover': '#1286A4',
            'generic.colors.text': '#252525',
            'generic.colors.hamburger': '#252525',
            'generic.colors.text.light': '#7c7c7c',
            'generic.borders.radius': '4px',
            // 'templates.create.icon': '/public/email-benvenuto-1.svg',
            // 'templates.create.title': intl.formatMessage({
            //   id: 'Load.Rcs.CreateNewMessage'
            // }),
            // 'templates.create.description': intl.formatMessage({
            //   id: 'Load.Rcs.CreateNewMessageDescription'
            // })
            'agents.create.icon': iconAgent,
            'agents.create.title': intl.formatMessage({
              id: 'Load.Rcs.CreateNewAgent'
            }),
            'agents.create.description': intl.formatMessage({
              id: 'Load.Rcs.CreateNewAgentDescription'
            })
          }
        })
      )
    }
  })

  const callback = async (action:string, data:composerData) => {
    switch (action) {
      case 'new-agent':
      case 'update-agent':
        addAgentDeclarationLog(data.agentId) 
        break
    }
  }

  return (
    <>
      <Header />
       <Page onReload={init}>
       
        {errorMessage === undefined && !loading && status==="ready" && token !== "" && (
        
            <div id='agent-list' className='composer' ref={composerRef} />
         
        )}
      </Page>
    </>
  )
}

export default RcsBot
